import classNames from 'classnames';
import React from 'react';
import { graphql } from 'react-apollo';
import { Button, Card, CardBody, Col, Container, Jumbotron, Row } from 'reactstrap';
import { compose, pure, withHandlers } from 'recompose';
import { eventValueHandler } from '../../../../common';
import { FormControlItem } from '../../../composed';
import { withState } from '../../../higher-order';
import './contact.css';
import contactQuery from './contact.gql';

const Contact = ({
  contactName,
  contactEmail,
  emailMessage,
  onSubmit,
  setContactName,
  setContactEmail,
  setEmailMessage,
  isValid,
  submitted
}) => (
    <section className='contact-us'>
      <Jumbotron tag='section' className='text-center'>
        <Container>
          <h1>Contact Form</h1>
        </Container>
      </Jumbotron>
      <Container>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <form
                  className={classNames({ 'was-validated': submitted })}
                  noValidate
                  onSubmit={onSubmit}
                >
                  <Row>
                    <Col>
                      <FormControlItem
                        id='contact-name'
                        icon='user'
                        label='Your name'
                        onChange={eventValueHandler(setContactName)}
                        readOnly={isValid}
                        required
                        value={contactName}
                      >
                        <div className='invalid-feedback ml-5'>
                          A contact name is required.
                        </div>
                      </FormControlItem>
                      <FormControlItem
                        id='contact-email'
                        icon='envelope'
                        label='Your email'
                        onChange={eventValueHandler(setContactEmail)}
                        readOnly={isValid}
                        required
                        type='email'
                        value={contactEmail}
                      >
                        <div className='invalid-feedback ml-5'>
                          A contact email is required.
                        </div>
                      </FormControlItem>
                      <FormControlItem
                        id='email-message'
                        className='md-textarea'
                        icon='comment'
                        label='Your message'
                        onChange={eventValueHandler(setEmailMessage)}
                        readOnly={isValid}
                        required
                        tag='textarea'
                        type={null}
                        value={emailMessage}
                      >
                        <div className='invalid-feedback ml-5'>
                          A message is required.
                        </div>
                      </FormControlItem>
                    </Col>
                  </Row>
                  <Row>
                    <Col className='text-center'>
                      {
                        isValid ?
                          <div className='d-block valid-feedback'>
                            Message Sent
                          </div> :
                          <Button color='primary' type='submit'>Submit</Button>
                      }
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );

export default compose(
  withState({
    contactName: '',
    contactEmail: '',
    emailMessage: '',
    isValid: false,
    submitted: false
  }),
  graphql(contactQuery, {
    options: { errorPolicy: 'all' },
    props: ({ mutate }) => ({
      submitContactForm: (contactForm) =>
        mutate({
          variables: {
            contactForm
          }
        })
    })
  }),
  withHandlers({
    onSubmit: ({
      contactName,
      contactEmail,
      emailMessage,
      setIsValid,
      setSubmitted,
      submitContactForm
    }) =>
      (e) => {
        e.preventDefault();
        e.stopPropagation();

        setSubmitted(true);

        if (e.target.checkValidity()) {
          setIsValid(true);

          submitContactForm({
            name: contactName,
            email: contactEmail,
            message: emailMessage
          });
        }
      }
  }),
  pure
)(Contact);



// WEBPACK FOOTER //
// ./src/components/pages/app/contact/contact.js